import { observer } from "mobx-react-lite";
import {
  Container,
  Divider,
  Grid,
} from "semantic-ui-react";
import { useTranslation } from "react-i18next";
import PageHeader from "../../app/layout/PageHeader";
import ARIndexResults from "./ARIndexResults";
import useQuery from "../../app/common/util/hooks";
import { useEffect } from "react";
import { useStore } from "../../app/stores/store";
import ARPaymentForm from "./ARPaymentForm";

type Props = {
  activeTab: number;
}

export default observer(function AccountsReceivableIndex(props: Props) {
  const { t } = useTranslation(["common", "customer"]);
  const { accountsReceivableStore, modalStore, pricingStore } = useStore();
  const { loadPaymentTicketsModal, loadAccountsReceivablePayModal } = accountsReceivableStore;
  const { dropdownPayTypesList, loadDropdownPayTypeList } = pricingStore;
  const customerId = useQuery().get('id');

  useEffect(
    () => {
      loadDropdownPayTypeList();
    },
    [loadDropdownPayTypeList]
  )

  async function loadTicketPayments(customerId: string) {
    return loadPaymentTicketsModal(customerId)
      .then(async (result: any) => {
        await loadAccountsReceivablePayModal(customerId);
        return result.data.sum;
      })
      .then((totalAmountDue: number) => {
        modalStore.openWidestModal(
          <ARPaymentForm
            customerId={customerId}
            isAdd={true}
            dropdownItems={dropdownPayTypesList}
            amountDue={totalAmountDue}
            addItem={() => { }}
          />
        );
      })
  }

  useEffect(
    () => {
      console.log('customerId:', customerId);
      if (customerId) {
        loadTicketPayments(customerId);
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [customerId]
  )

  return (
    <>
      <Grid stackable columns={2}>
        <Grid.Column>
          <PageHeader
            header={t("accountsReceivable", { ns: "accountsReceivable" })}
            type="h1"
            divider={false}
            getAlerts={true}
            addTitle={true}
          />
        </Grid.Column>
        <Grid.Column textAlign="right"></Grid.Column>
      </Grid>
      <Divider />
      <Container className="page">
        <ARIndexResults />
      </Container>
    </>
  );
});
